export type UserTypeDTO = (typeof UserTypeDTO)[keyof typeof UserTypeDTO];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserTypeDTO = {
  admin: 'admin',
  'bearer-manager': 'bearer-manager',
  viewer: 'viewer',
} as const;
